/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompanyResource
 */
export interface FreelancerCompanyResource {
    /**
     * 
     * @type {boolean}
     * @memberof FreelancerCompanyResource
     */
    showLogoutButton: boolean;
}

/**
 * Check if a given object implements the FreelancerCompanyResource interface.
 */
export function instanceOfFreelancerCompanyResource(value: object): value is FreelancerCompanyResource {
    if (!('showLogoutButton' in value) || value['showLogoutButton'] === undefined) return false;
    return true;
}

export function FreelancerCompanyResourceFromJSON(json: any): FreelancerCompanyResource {
    return FreelancerCompanyResourceFromJSONTyped(json, false);
}

export function FreelancerCompanyResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyResource {
    if (json == null) {
        return json;
    }
    return {
        
        'showLogoutButton': json['showLogoutButton'],
    };
}

export function FreelancerCompanyResourceToJSON(value?: FreelancerCompanyResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'showLogoutButton': value['showLogoutButton'],
    };
}

